export default __webpack_public_path__ + "static/media/kato.92d8a435.svg";